/**
 * Class to manage delivery/billing/Gift Aid addresses on the Donate Form and Ticketing Form
 */

import Loqate    from 'Scripts/donate-form/loqate';
import TomSelect from 'Scripts/common/tom-select';

// TomSelect makes a <select> searchable
export function enableTomSelects(selectors) {
	selectors.forEach(selector => {
		new TomSelect(selector, {
			disableAutocomplete: true,
		});
	});
}

// Loqate is our address auto-complete tool
export function enableLoqate(selectors) {
	selectors.forEach(selector => {
		// TODO: enterManuallyBtn can probably be moved into the Loqate class rather than be passed manually like this
		new Loqate({ 
			input: $(selector), 
			enterManuallyBtn: $($(selector).data('manualButton')),
		});
	});
}

// If a country dropdown is changed, update the country/state and postcode/zipcode labels depending on if US or UK
export function enablePostcodeLabelToggle() {
	$(".js-country-select").on('change', e => {
		const el = $(e.currentTarget);

		const county = $(el.data('county'));
		const postcode = $(el.data('postcode'));

		const countyLabel = county.siblings("label");
		const postcodeLabel = postcode.siblings("label");

		const messagePrefix = "Please enter your ";

		if(el.val() == 'US') {
			countyLabel.text("State");
			postcodeLabel.text("Zip code");
			county.parsley().options.requiredMessage = messagePrefix + "state";
			postcode.parsley().options.requiredMessage = messagePrefix + "zip code";
		} else {
			countyLabel.text("County");
			postcodeLabel.text("Postcode");
			county.parsley().options.requiredMessage = messagePrefix + "county";
			postcode.parsley().options.requiredMessage = messagePrefix + "postcode";
		}
	});
}